import { render, staticRenderFns } from "./CasesStateChart.vue?vue&type=template&id=6bc58b3f&scoped=true"
import script from "./CasesStateChart.vue?vue&type=script&lang=js"
export * from "./CasesStateChart.vue?vue&type=script&lang=js"
import style0 from "./CasesStateChart.vue?vue&type=style&index=0&id=6bc58b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc58b3f",
  null
  
)

export default component.exports